import React, { Component } from "react";
import { Field } from "redux-form";
import { Row, Col } from "react-bootstrap";

import Select2 from "../../../../../components/common/select/Select2";
import { required } from "../../../../../utils/forms/validators";
// import styles from "./FilterBox.scss";

const CATEGORIES = [
  { id: 1, value: "Metro Area" },
  { id: 2, value: "Skills" },
  { id: 3, value: "Level" },
  { id: 4, value: "Industry" },
  { id: 5, value: "Available for Full Time" }
];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  getSkillsByCategory() {
    let allSkills = [];
    this.props.skillsOptions.forEach(skill => {
      allSkills = allSkills.concat(skill.skills);
    });

    const category = this.props.selectedSkillCategory[
      this.props.selectedSkillCategory.length - 1
    ];
    if (!category || category < 0)
      return allSkills.map(skill => ({ ...skill, value: skill.name }));
    const filtered = this.props.skillsOptions.filter(s => s.id == category);
    if (!filtered || filtered.length <= 0) return [];

    return filtered[0].skills.map(skill => ({ ...skill, value: skill.name }));
  }

  renderMetroArea() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.metro_area`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.commuteCitiesOptions}
      />
    );
  }

  renderSkills() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.skill`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.getSkillsByCategory()}
      />
    );
  }

  renderLevels() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.level`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.levelsOptions}
      />
    );
  }

  renderIndustries() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.industry`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.industriesOptions}
      />
    );
  }

  renderAvailability() {
    const availability = [
      {
        id: 1,
        value: "Yes"
      },
      {
        id: 0,
        value: "No"
      }
    ];

    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.full_time_job`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={availability}
      />
    );
  }

  renderCriteria() {
    switch (this.state.selectedCategory) {
      case 1:
        return this.renderMetroArea();
      case 2:
        return this.renderSkills();
      case 3:
        return this.renderLevels();
      case 4:
        return this.renderIndustries();
      case 5:
        return this.renderAvailability();
      default:
        return null;
    }
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Category"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderCriteria()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/project/matches/components/FilterBox.js